import React, { Component } from "react";
import { Dialog, Classes, Spinner } from "@blueprintjs/core";
import { FormattedMessage } from "react-intl";
import { IconNames } from "@blueprintjs/icons";
import { generateReportDownloadURL } from "../../api";
import { showToast } from "../../utils";
import styles from "../../styles/Popup.module.scss";

class ReportDownloadModal extends Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    // Automatically start download when modal opens
    this.handleDownload();
  }

  handleDownload = async () => {
    const { s3Url, onClose } = this.props;

    try {
      // Call the API to generate a fresh presigned URL
      const response = await generateReportDownloadURL(s3Url);
      const { downloadUrl } = response.data;

      // Open the download URL in a new tab or trigger download
      window.open(downloadUrl, "_blank");

      showToast("Report download started.", true, 3000);

      // Close the modal after successful download
      setTimeout(() => {
        this.setState({ isLoading: false });
        onClose();
      }, 1500);
    } catch (error) {
      showToast("Failed to generate download URL. Please try again.", false, 5000);
      this.setState({ isLoading: false });
      // Close modal after error
      setTimeout(() => {
        onClose();
      }, 2000);
    }
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { isLoading } = this.state;

    const content = isLoading ? (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner size={50} />
        <p style={{ marginTop: "20px", color: "#5c7080" }}>
          <FormattedMessage
            id="ReportDownload.generating"
            defaultMessage="Generating your download link..."
          />
        </p>
      </div>
    ) : (
      <p>
        <FormattedMessage
          id="ReportDownload.completed"
          defaultMessage="Your download has started. This window will close automatically."
        />
      </p>
    );

    return (
      <Dialog
        isOpen={isOpen}
        icon={IconNames.DOWNLOAD}
        onClose={onClose}
        title={<FormattedMessage id="ReportDownload.title" defaultMessage="Download Report" />}
        className={styles.popup}
        canOutsideClickClose={false}
        canEscapeKeyClose={false}
      >
        <div className={Classes.DIALOG_BODY}>{content}</div>
      </Dialog>
    );
  }
}

export default ReportDownloadModal;
